import { FlashMessageGenerateTokenDto } from "../../dto/flashmessagegenereratetoken/flashmessagegeneratetoken";
import { MiddlewareDtoImpl } from "../../dto/middlewaredto";
import { MiddlewareAPIResponse } from "../middlewareapiresponse";

export interface FlashMessageGenerateTokenResponse extends MiddlewareAPIResponse
{
    getFlashMessageGenerateTokenResponseDto(): FlashMessageGenerateTokenDto;
}

export class FlashMessageGenerateTokenResponseDtoImpl extends MiddlewareDtoImpl implements FlashMessageGenerateTokenResponse
{
    private getFlashMessageGenerateTokenDto : FlashMessageGenerateTokenDto;

    getFlashMessageGenerateTokenResponseDto(): FlashMessageGenerateTokenDto
    {
        return this.getFlashMessageGenerateTokenDto;
    }

    setFlashMessageGenerateTokenResponseDto(getFlashMessageGenerateTokenDto: FlashMessageGenerateTokenDto)
    {
        this.getFlashMessageGenerateTokenDto = getFlashMessageGenerateTokenDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessagegeneratetoken/flashmessagegeneratetokenresponse.tsx